<template>
    <div class="Exporter">
        <ul class="Utility__list-inline">
            <li>
                <a href="#" title="Export to PDF" @click.prevent="exportToPdf()">
                    <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                </a>
            </li>
        </ul>

        <form action="/motorstats/export/graph" method="post" ref="form">
            <input name="_token" type="hidden" :value="csrfToken">
            <input name="title" type="hidden" :value="title">
            <input name="graph" type="hidden" :value="graph">
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                csrfToken: Laravel.csrfToken,
                graph: '',
            }
        },

        mounted() {
            bus.$on('graph-data-response', (title, graph) => {
                if (this.title == title) {
                    this.graph = graph;

                    _.defer(() => {
                        this.$refs.form.submit();
                    })
                }
            })
        },

        props: {
            title: {
                type: String,
                required: true,
            },
        },

        methods: {
            exportToPdf() {
                bus.$emit('request-graph-data', this.title);
            }
        }
    }
</script>